import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store';
import { fetchCreateTheme } from 'src/app/store/states/config/config.actions';

@Injectable({
  providedIn: 'root',
})
export class DataServiceService {
  windowUrl = window.location.href;

  constructor(private store: Store<AppState>) {}

  async getConfiguration(): Promise<void> {
    this.store.dispatch(fetchCreateTheme({ url: this.windowUrl }));
  }
}
